import "./Form.css"

export default {
	name: "eiis-form",
	props: {
		name: String, header: String, background: String, border: Boolean,
		statusMessage: String, errorMessage: String,
		fields: Array,
		submitButtonText: String, cancelButtonText: String
	},
	data: function () {
		return {
			status: this.statusMessage,
			error: this.errorMessage,
		}
	},
	methods: {
		setStatusMessage: function (msg) {
			this.status = msg
		},
		setErrorMessage: function (msg) {
			this.error = msg
		},
		getString: function (key) {
			// TODO lookup language string based on the key
			let str = key;
			return str;
		},
		onSubmit: function () {
			let vm = this;
			vm.error = "";
			this.fields.forEach(function (field) {
				if (field.Required) {
					if (!field.model) {
						vm.error += "Please fill out mandatory field: " + field.Label + "<br>";
					}
				}
			});
			if (vm.error)
				return;
			this.$emit('formsubmit', {
				event: 'formsubmit',
				form: this.name,
				fields: this.fields
			});
		}
	},
	template: `
    <eiis-panel 
      v-bind:header="header"
      v-bind:border=true
      v-bind:statusMessage="status"
      v-bind:errorMessage="error"
			v-bind:footer=true
      >
  
      <slot></slot>

      <form>
        <div class="eiis-form-body container">
          <div class="row eiis-form-row" v-for="field in fields">
            <div class="col-md-3 eiis-form-label">
              <label v-bind:for="field.Model">{{field.Label}}</label>
            </div>

            <div class="col-md-8 eiis-form-field">
              <input v-model="field.model" class="form-control"
                  v-bind:placeholder="field.Placeholder" 
                  v-bind:type="field.Type" autofocus
                  v-bind:value="field.Value"
                  v-on:keyup.enter="onSubmit"
              />
            </div>
          </div>
        </div>
      </form>

			<div slot="footer">
        <div id="spinner" class="float-start"></div>
        <eiis-button type="submit btn-primary" name="submit-button"
            event="formsubmit" v-on:formsubmit=this.onSubmit 
            v-on:click=this.onSubmit 
           v-bind:text=submitButtonText 
        ></eiis-button>
     </div>	
    </eiis-panel>
  `
}